import { useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import { MiDetailPageHeader } from "@miplatform/components";
import { useRouter } from "@miplatform/hooks";
import { mdiChevronLeft } from "@mdi/js";
import { Box } from "@mui/material";
import {
  USER_PROFILE_FORM_SECTIONS,
  UserProfile,
} from "../../../../components/UserProfile/UserProfile";
import { useUserDetailsViewModel } from "./UserDetailViewModel";

export function UserDetails() {
  const {
    location: { state },
    params: { id: userId },
  } = useRouter();

  const roles = state?.roles;

  const { classes } = useStyles();

  const {
    isLoading,
    user,
    updateUser,
    getUser,
    activateUser,
    deactivateUser,
    uploadProfilePhoto,
    deleteProfilePhoto,
    getProfilePhotoUrl,
  } = useUserDetailsViewModel();

  useEffect(() => {
    if (userId) {
      getUser(userId);
    }
  }, [userId]);

  const handleUpdate = async (data, edit) => {
    const { id: userId, modifiedOn } = edit.getValue();
    const { isDisabled, ...dataToUpdate } = data;
    let userResponse = null;
    if (Object.keys(dataToUpdate).length > 1) {
      userResponse = await updateUser(userId, {
        ...dataToUpdate,
        modifiedOn,
      });
    }

    const latestModifiedOn = userResponse?.modifiedOn || modifiedOn;
    if (typeof isDisabled === "boolean") {
      if (isDisabled) {
        userResponse = await deactivateUser(userId, {
          modifiedOn: latestModifiedOn,
        });
      } else {
        userResponse = await activateUser(userId, {
          modifiedOn: latestModifiedOn,
        });
      }
    }
    if (userResponse) {
      getUser(userId);
      edit.reset();
    }
  };

  return (
    <Box className={classes.contentContainer}>
      <MiDetailPageHeader
        title="User Details"
        titleIcon={mdiChevronLeft}
        loading={isLoading}
      />
      <UserProfile
        user={user}
        roles={roles}
        handleUpdate={handleUpdate}
        isLoading={isLoading}
        uploadProfilePhoto={uploadProfilePhoto}
        deleteProfilePhoto={deleteProfilePhoto}
        getProfilePhotoUrl={getProfilePhotoUrl}
        sections={[
          USER_PROFILE_FORM_SECTIONS.BASIC_INFO,
          USER_PROFILE_FORM_SECTIONS.ADMIN,
          USER_PROFILE_FORM_SECTIONS.PREFERENCES,
          USER_PROFILE_FORM_SECTIONS.CONTACT_INFO,
        ]}
      />
    </Box>
  );
}

const useStyles = makeStyles()(() => ({
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "inherit",
  },
}));
